// extracted by mini-css-extract-plugin
export var card = "ReferenceSectionColumn-module--card--7f1db";
export var cardBody = "ReferenceSectionColumn-module--cardBody--82327";
export var cardTitle = "ReferenceSectionColumn-module--cardTitle--e1702";
export var divider = "ReferenceSectionColumn-module--divider--04d70";
export var header = "ReferenceSectionColumn-module--header--6ad65";
export var referencedSection = "ReferenceSectionColumn-module--referencedSection--92ae0";
export var subHeading = "ReferenceSectionColumn-module--subHeading--f6ab1";
export var subHeadingSpan = "ReferenceSectionColumn-module--subHeadingSpan--3b2c0";
export var title = "ReferenceSectionColumn-module--title--f2515";